/**
 * Textos de respaldo para etiquetas del rail / submenú v3 (`buildPrivateNavItems`).
 * Alineados al catálogo i18n cuando existe; si no hay mensaje en store, se usa este mapa.
 */
const NAV_RAIL_LABEL_FALLBACK = {
    "administration.menu.groups": "Grupos",
    "administration.menu.name": "Administración",
    "administration.menu.signatureScheme": "Esquema de firmas",
    "administration.menu.users": "Usuarios",
    "administration.restrictions.environment.title": "Restricciones",
    "credin.main.label": "Enviar CREDIN",
    "frequentDestinationList.main.label": "Agenda",
    "header.user.menu.goToAccountOfficial": "Cuenta oficial",
    "header.user.menu.goToConfig": "Configuración",
    "header.user.menu.handleLogout": "Cerrar sesión",
    "menu.accounts.myAccounts": "Mis cuentas",
    "menu.charges": "Cobros",
    "menu.checks": "Cheques",
    "menu.checks.echeqs": "Operar con ECHEQs",
    "menu.checks.echeqsControl": "Control de ECHEQs",
    "menu.checks.list.checksDetail": "Consulta de cheques",
    "menu.checks.requestCheckbook": "Solicitud de Chequera",
    "menu.checks.rule.manage": "Automatización de ECHEQs",
    "menu.checks.massiveEcheq.manage": "Gestión masiva de ECHEQs",
    "menu.corporateCard": "Tarjeta Corporativa",
    "menu.deposits.myDeposits": "Depositar a plazo",
    "menu.desktop": "Inicio",
    "menu.directDebit": "Solicitud de Débitos directos",
    "menu.ecomex": "Comercio Exterior",
    "menu.ecomex.alertsAndDues": "Alertas y vencimientos",
    "menu.ecomex.consultOperations": "Consultar operaciones",
    "menu.ecomex.enterRequests": "Ingresar solicitudes",
    "menu.ecomex.informativeRegime": "Régimen informativo",
    "menu.ecomex.requestsHistory": "Historial de solicitudes",
    "menu.financing": "Financiaciones",
    "menu.fixedTermAcceptance": "Aceptacion Plazo Fijo Web",
    "menu.fundcorp.fundInformation": "Información de fondos",
    "menu.generateDebin": "Generar DEBIN",
    "menu.invesments.tradeFunds": "Operar con fondos",
    "menu.investments": "Inversiones",
    "menu.investments.currencyExchange": "Compra/Venta de Moneda Extranjera",
    "menu.investments.manageCedip": "Gestionar CEDIP",
    "menu.metrocorp": "Metrocorp",
    "menu.multiple.transfers": "Pagar por transferencias masivas",
    "menu.multiple.transfers.old": "Transferencias múltiples",
    "menu.payments": "Pagos",
    "menu.payments.payDebin": "Pagar DEBIN",
    "menu.payments.payServicesAfip": "Pagar servicios y AFIP",
    "menu.payments.payServices.arca": "Pagar servicios y ARCA",
    "menu.payments.payThirdParties": "Pagar a terceros",
    "menu.settings": "Perfil",
    "menu.token": "Token CMF",
    "menu.v3.bottomNav.token": "Token",
    "menu.v3.bottomNav.funds": "Fondos",
    "menu.transactions": "Historial",
    "menu.transfers": "Transferencias",
    "menu.v3.rail.authorizations": "Autorizaciones",
    "settings.token": "Configurar Token",
    "transfers.main.label": "Transferir",
};

export default NAV_RAIL_LABEL_FALLBACK;
